import { TeleconsultationDrawer } from "@/modules/patients/agenda/teleconsultation/booking/teleconsultation-drawer"
import { EpisodeOfCareProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"
import { useConfirmStore } from "@/stores/useConfirmStore"
import { useDrawerStore } from "@/stores/useDrawerStore"
import { Country, PointOfCareType } from "@/types/__generated__/union-types"

interface UseTelecareFollowUpSuggestionArgs {
  progressNote: EpisodeOfCareProgressNoteData
  countryCode: Country
  patientId: string
}

const useTelecareFollowUpSuggestion = ({ progressNote, countryCode, patientId }: UseTelecareFollowUpSuggestionArgs) => {
  const confirm = useConfirmStore((state) => state.confirm)
  const openDrawer = useDrawerStore((state) => state.openDrawer)

  const triggerSuggestionIfApplicable = async (newValue: PointOfCareType | null | undefined): Promise<void> => {
    if (newValue !== "TELECARE") return
    if (progressNote.followUpAppointment !== null) return

    const confirmed = await confirm({
      title: "episodeOfCare.progressNote.followUpSuggestion.title",
      content: "episodeOfCare.progressNote.followUpSuggestion.content",
      confirmText: "episodeOfCare.progressNote.followUpSuggestion.confirm",
      cancelText: "common.button.cancel",
    })

    if (!confirmed) return

    openDrawer(
      () => (
        <TeleconsultationDrawer
          mode={{ kind: "FOLLOWUP_FOR_PROGRESS_NOTE", data: { progressNote } }}
          countryCode={countryCode}
          patientId={patientId}
          appointmentId={null}
        />
      ),
      "TeleconsultationDrawer",
    )
  }

  return { triggerSuggestionIfApplicable }
}

export { useTelecareFollowUpSuggestion }
